import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../api/client";

export default function ProtectedRoute({ children }) {
    return auth.isLoggedIn() ? children : <Navigate to="/auth-login" replace />;
}
